const EnumSizes = ['small', 'medium', 'large', 'fullscreen'];
function isEnumSize(size) {
    return typeof size === 'string' && EnumSizes.includes(size);
}
function isCustomSize(size) {
    return typeof size === 'object' && 'w' in size && 'h' in size;
}

export { isCustomSize, isEnumSize };
//# sourceMappingURL=types.js.map
